
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ProgramsHeroSection from './components/ProgramsHeroSection';
import EducationHubSection from './components/EducationHubSection';
import AdvocacySection from './components/AdvocacySection';
import CommunitySection from './components/CommunitySection';
import WellnessAcademySection from './components/WellnessAcademySection';
import UpcomingEventsSection from './components/UpcomingEventsSection';
import ProgramsCTASection from './components/ProgramsCTASection';

export default function Programs() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <ProgramsHeroSection />
        <EducationHubSection />
        <AdvocacySection />
        <CommunitySection />
        <WellnessAcademySection />
        <UpcomingEventsSection />
        <ProgramsCTASection />
      </main>
      <Footer />
    </div>
  );
}
